
export class Address {
  addressLine: any;
  locality: string;
  adminDistrict: string;
  postalCode: string;
  country: string;
  formattedAddress: string;

  constructor(
    addressLine: any,
    adminDistrict: string,
    country: string,
    formattedAddress: string,
    locality: string,
    postalCode: string
  ) {
    this.addressLine = addressLine;
    this.locality = locality;
    this.adminDistrict = adminDistrict;
    this.postalCode = postalCode;
    this.country = country;
    this.formattedAddress = formattedAddress;
  }
}